import { render, staticRenderFns } from "./OperationsSummary.vue?vue&type=template&id=227bc56c"
import script from "./OperationsSummary.vue?vue&type=script&lang=js"
export * from "./OperationsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports